type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  children: React.ReactNode;
};

const Link: React.FC<LinkProps> = ({ href, children, ...props }) => {
  let finalHref = href;

  if (!href.startsWith('/') && !href.includes('://')) {
    finalHref = `/${href}`;
  }

  return (
    <a href={finalHref} {...props}>
      {children}
    </a>
  );
};

export { Link };
